<template>
    <div class="recover-password-wrap col-md-8 mx-auto border rounded px-2 py-2">
        <div class="title-wrap border-bottom mb-3">
            <h1>Смена пароля</h1>
        </div>
        <div class="w-100 form-wrap">
            <b-form>
                <b-form-group id="input-password1" label="Новый пароль:" label-for="password1" class="text-left">
                    <b-form-input
                            id="password1"
                            v-model="form.password1"
                            type="password"
                            placeholder=""
                    ></b-form-input>
                </b-form-group>

                <b-form-group id="input-password2" label="Пароль (еще раз):" label-for="password2" class="text-left">
                    <b-form-input
                            id="password2"
                            v-model="form.password2"
                            type="password"
                            placeholder=""
                    ></b-form-input>
                </b-form-group>
            </b-form>

            <b-button type="submit" variant="success" class="w-100" @click="changePassword()">Изменить пароль</b-button>
        </div>
    </div>
</template>

<style lang="scss">
    .profile-wrap {
        background-color: #f2f2f2;
    }
    .title-wrap h1 {
        line-height: 85px;
    }
</style>

<script>
  import axios from 'axios';
  import { apiRoot } from "@/helpers/variables";
  import mixinUtils from "@/components/mixinUtils";
  export default {
    name: 'change-password',
    mixins: [mixinUtils],
    components: {
    },
    data: () => ({
      form: {
        password1: null,
        password2: null,
      }
    }),
    methods: {
      changePassword () {
        const context = this
        if (context.form.password1 !== context.form.password2) {
          this.$bvToast.toast(`Пароли не совпадают`, {
            title: 'Ошибка',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: false,
            toaster: 'b-toaster-bottom-right',
          })
          return;
        }

        axios.post(`${apiRoot}users/update-lost-password`, {
            username: context.$route.query.email,
            password: context.form.password1,
        }, {
          withCredentials: false,
          crossdomain: true,
          headers: {
            Authorization: `Bearer ${this.$route.query.token}`,
          }
        }).then(response => {
          this.$store.commit('setUser', response.data);

          this.$bvToast.toast(`Вы успешно сменили пароль для ${response.data.username}`, {
            title: 'Восстановление доступа',
            autoHideDelay: 5000,
            variant: 'success',
            appendToast: false,
            toaster: 'b-toaster-bottom-right',
          })

          this.$router.push({path: '/profile'})
        }).catch(error => {
          switch (error.response.status) {
            default:
              this.$bvToast.toast(`${error.message}`, {
                title: 'Ошибка',
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
              break;
          }

        });
      }
    },
    mounted() {
      if (this.$route.query.token === undefined || this.$route.query.email === undefined) {
        this.$router.push({path: '/recover-password'})
      }
    }
  }
</script>